(() => {
  'use strict';

  const config = window.apothexxFreeGiftConfig;

  if (!config) {
    console.warn(
      '[Apothexx free gifts] Missing configuration.'
    );
    return;
  }

  const qualifyingVariantIds = new Set(
    (config.qualifyingVariantIds || []).map(Number)
  );

  const giftVariantIds = [
    ...new Set(
      (config.giftVariantIds || [])
        .map(Number)
        .filter(Boolean)
    )
  ];

  const routesRoot =
    window.Shopify?.routes?.root || '/';

  let synchronizing = false;
  let synchronizeAgain = false;
  let timer = null;

  const request = async (path, options = {}) => {
    const response = await fetch(
      `${routesRoot}${path}`,
      {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          ...(options.body
            ? { 'Content-Type': 'application/json' }
            : {}),
          ...(options.headers || {})
        }
      }
    );

    if (!response.ok) {
      const message = await response.text();

      throw new Error(
        `${response.status}: ${message}`
      );
    }

    return response.json();
  };

  const getCart = () => request('cart.js');

  const isQualifyingItem = (item) =>
    qualifyingVariantIds.has(
      Number(item.variant_id || item.id)
    );

  const getQualifyingQuantity = (cart) =>
    cart.items
      .filter(isQualifyingItem)
      .reduce(
        (quantity, item) =>
          quantity + item.quantity,
        0
      );

  const isGift = (item) =>
    giftVariantIds.includes(
      Number(item.variant_id || item.id)
    );

  /*
   * Oznakom source sprječavamo da gift sustav
   * reagira na vlastiti cart:refresh i napravi petlju.
   */
  const refreshFocalCart = () => {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          source: 'apothexx-free-gifts'
        }
      })
    );
  };

  const reconcileCart = async () => {
    if (synchronizing) {
      synchronizeAgain = true;
      return;
    }

    synchronizing = true;

    try {
      const cart = await getCart();

      const requiredGiftQuantity =
        getQualifyingQuantity(cart);

      const qualifies =
        requiredGiftQuantity > 0;

      const giftsInCart =
        cart.items.filter(isGift);

      const updates = {};
      const presentGiftVariantIds = new Set();

      /*
       * Uskladi količinu svih postojećih poklona
       * s ukupnom količinom qualifying proizvoda.
       */
      for (const item of giftsInCart) {
        const variantId = Number(
          item.variant_id || item.id
        );

        /*
         * Ukloni poklone ako više nema qualifying
         * proizvoda ili ako postoji duplicirana linija.
         */
        if (
          !qualifies ||
          presentGiftVariantIds.has(variantId)
        ) {
          updates[item.key] = 0;
          continue;
        }

        presentGiftVariantIds.add(variantId);

        if (
          item.quantity !==
          requiredGiftQuantity
        ) {
          updates[item.key] =
            requiredGiftQuantity;
        }
      }

      let changed = false;

      /*
       * Ažuriraj količinu postojećih poklona.
       */
      if (Object.keys(updates).length > 0) {
        await request('cart/update.js', {
          method: 'POST',
          body: JSON.stringify({
            updates
          })
        });

        changed = true;
      }

      /*
       * Dodaj poklone koji nedostaju.
       */
      if (qualifies) {
        const missingGiftVariantIds =
          giftVariantIds.filter(
            (variantId) =>
              !presentGiftVariantIds.has(
                variantId
              )
          );

        if (
          missingGiftVariantIds.length > 0
        ) {
          await request('cart/add.js', {
            method: 'POST',
            body: JSON.stringify({
              items:
                missingGiftVariantIds.map(
                  (variantId) => ({
                    id: variantId,
                    quantity:
                      requiredGiftQuantity
                  })
                )
            })
          });

          changed = true;
        }
      }

      /*
       * Osvježi Focal cart drawer tek nakon što
       * su količine svih poklona usklađene.
       */
      if (changed) {
        refreshFocalCart();
      }
    } catch (error) {
      console.error(
        '[Apothexx free gifts]',
        error
      );
    } finally {
      synchronizing = false;

      if (synchronizeAgain) {
        synchronizeAgain = false;
        scheduleSynchronization(100);
      }
    }
  };

  function scheduleSynchronization(
    delay = 150
  ) {
    window.clearTimeout(timer);

    timer = window.setTimeout(
      reconcileCart,
      delay
    );
  }

  /*
   * Provjera pri prvom učitavanju stranice.
   */
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      scheduleSynchronization(0);
    }
  );

  /*
   * Ispravni Focal događaji.
   */
  document.addEventListener(
    'variant:add',
    () => {
      scheduleSynchronization();
    }
  );

  document.addEventListener(
    'cart:change',
    () => {
      scheduleSynchronization();
    }
  );

  /*
   * Ostavljamo i stare nazive radi kompatibilnosti
   * s eventualnim drugim kodom ili aplikacijama.
   */
  document.addEventListener(
    'variant:added',
    () => {
      scheduleSynchronization();
    }
  );

  document.addEventListener(
    'cart:updated',
    () => {
      scheduleSynchronization();
    }
  );

  /*
   * OVO POVEZUJE NOVI UPSELL GUMB S POKLONIMA.
   *
   * Upsell gumb nakon dodavanja proizvoda šalje
   * cart:refresh. Tada ponovno izračunavamo poklone.
   *
   * Ignoriramo cart:refresh koji je poslao sam
   * free-gift sustav kako ne bi nastala petlja.
   */
  document.addEventListener(
    'cart:refresh',
    (event) => {
      if (
        event.detail?.source ===
        'apothexx-free-gifts'
      ) {
        return;
      }

      scheduleSynchronization(50);
    }
  );

  /*
   * Provjera pri povratku na stranicu iz
   * browser back/forward cachea.
   */
  window.addEventListener(
    'pageshow',
    () => {
      scheduleSynchronization(0);
    }
  );
})();